import React from 'react';
import PlayerListing from './PlayerListing'
import PitchView from './PitchView';
import AdBottom from '../AdBottom';
import OutsideNotifier from '../../OutsideNotifier'
import PlayerRecomendationPopUp from './filters/PlayerRecomendationPopUp'
import PlayerRecomendationPopUpMob from './filters/PlayerRecomendationPopUpMob'

const MainPitch = (props) => {
    return <React.Fragment>
        <div className="si-wrap si-flexBox">
            {props.toShowList ? <PlayerListing /> : null}
            {props.showPlayerRecomendationPopUp ? <OutsideNotifier handler={() => props.showHidePlayerRecomendationPopUp(false)}><PlayerRecomendationPopUp setPlayerRecomendationFirstTimeFalse={props.setPlayerRecomendationFirstTimeFalse} showHidePlayerRecomendationPopUp={props.showHidePlayerRecomendationPopUp}></PlayerRecomendationPopUp> </OutsideNotifier> : null}

            {props.showPlayerrecomendationPopupMobile ? <OutsideNotifier handler={() => props.showHidePlayerRecomendationPopUpMob(false)}><PlayerRecomendationPopUpMob showHidePlayerRecomendationPopUpMob={props.showHidePlayerRecomendationPopUpMob}></PlayerRecomendationPopUpMob> </OutsideNotifier> : null}
            <PitchView {...props} />
        </div>
        <AdBottom />
        <div className="si-bottom-bg" />
    </React.Fragment>
};
export default MainPitch;


// WEBPACK FOOTER //
// ./src/components/onboarding/MainPitch.js